import GasCylinderOwnersFundTool from './GasCylinderOwnersFundTool';

export default function FleetCardOwnersFundPanel({
  pumpId,
  fromDate,
  toDate,
  disabled = false,
  onPreviewStart,
  onPreviewEnd,
  onApplyStart,
  onApplyEnd,
  onCompleted,
  onOpenHistory,
}) {
  return (
    <div className="admin-panel fleet-card-owners-fund-panel">
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
        <div>
          <h5 className="mb-1">Fleet card — Owners Fund ledger repair</h5>
          <p className="small text-muted mb-0">
            Finds fleet card sales posted to inactive or wrong balance-sheet accounts (or duplicated rows), reposts to the active fleet card, and saves a full audit trail in Fix history.
          </p>
        </div>
        {onOpenHistory && (
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onOpenHistory} disabled={disabled}>
            Fix history & undo
          </button>
        )}
      </div>

      <GasCylinderOwnersFundTool
        pumpId={pumpId}
        fromDate={fromDate}
        toDate={toDate}
        disabled={disabled}
        onPreviewStart={onPreviewStart}
        onPreviewEnd={onPreviewEnd}
        onApplyStart={onApplyStart}
        onApplyEnd={onApplyEnd}
        onCompleted={onCompleted}
        fixType="fleet_card_owners_fund_align"
        findingType="fleet_card_owners_fund_align"
        title="Fleet card sales (inactive / wrong head)"
        description="Typical cause: Dr on inactive generic Fleet Card while employee Cr is active — Owners Fund counts only the credit side. Also fixes duplicate Dr/Cr pairs."
        scanLabel="Find fleet card ledger mismatches"
        applyLabel="Apply fleet card Owners Fund fix"
        emptyMessage="No fleet card ledger repairs needed in this date range."
      />
    </div>
  );
}
